import { ValueObject } from '@keyvue/one-api-client';
import { object, Schema, string } from 'yup';

class TagCategory extends ValueObject {
    get label(): string {
        return {
            [TagCategory.URGENT.value]: 'Urgent / Ontevreden',
            [TagCategory.POSITIVE.value]: 'Positief',
            [TagCategory.INFORMATION.value]: 'Informatie / zakelijk',
            [TagCategory.ACTION.value]: 'Vervolgactie',
            [TagCategory.NO_CONVERSATION.value]: 'Geen gesprek',
            [TagCategory.IMPORTANT.value]: 'Belangrijk / Waarschuwing',
            [TagCategory.SUPPORT.value]: 'Support / Productvraag',
            [TagCategory.PREFERENCE.value]: 'Voorkeur / Mening',
        }[this.value];
    }

    // Some error about builded types not matching
    // @ts-ignore
    // eslint-disable-next-line
    get schemaConfig(): Schema {
        return TagCategory.validationSchema;
    }

    static get validationSchema(): Schema {
        return object({
            value: string().oneOf(
                TagCategory.values.map((tag: TagCategory) => tag.value),
            ),
        });
    }

    static get values() {
        return [
            TagCategory.URGENT,
            TagCategory.POSITIVE,
            TagCategory.INFORMATION,
            TagCategory.ACTION,
            TagCategory.NO_CONVERSATION,
            TagCategory.IMPORTANT,
            TagCategory.SUPPORT,
            TagCategory.PREFERENCE,
        ];
    }

    static URGENT = new TagCategory('#FF0000');

    static POSITIVE = new TagCategory('#008000');

    static INFORMATION = new TagCategory('#0000FF');

    static ACTION = new TagCategory('#FFA500');

    static NO_CONVERSATION = new TagCategory('#808080');

    static IMPORTANT = new TagCategory('#FFFF00');

    static SUPPORT = new TagCategory('#800080');

    static PREFERENCE = new TagCategory('#FFC0CB');
}

export default TagCategory;
